import {Statistic} from 'antd';
import {useEffect, useMemo, useState} from "react";
import {StateText} from "@/utils/stateChange";

const {Countdown} = Statistic;

export default function StateTitle({getStatus, state}: {
    getStatus: () => void,
    state: { bitcoinState: number, fractalState: number }
}) {
    const [countDown, setCountDown] = useState<{
        M: number,
        S: number
    }>({
        M: 5,
        S: Date.now() + 1000 * 60
    })
    const [titleTime, setTitleTime] = useState<string>(new Date().toLocaleString())

    const countDownChange = () => {
        if (!countDown.M) {
            setCountDown({
                M: 5,
                S: Date.now() + 1000 * 60
            })
            setTitleTime(new Date().toLocaleString())
            getStatus()
            return
        }
        setCountDown({
            M: countDown.M - 1,
            S: Date.now() + 1000 * 60
        })
    }

    const iconClass = useMemo(() => {
        if (state.fractalState === 0 && state.bitcoinState === 0) {
            return 'text-[#F55454] bg-[#F5545430] border-error'
        }

        if (state.fractalState === 2 || state.bitcoinState === 2 || state.fractalState === 0 || state.bitcoinState === 0) {
            return 'text-[#F4B62C] bg-[#F4B62C30] border-padding'
        }

        return 'text-[#3AC79D] bg-[#071813] border-systems'
    }, [state])

    const iconSvg = useMemo(() => {
        if (state.fractalState === 0 && state.bitcoinState === 0) {
            return <img src="/img/systems-error.svg" alt="App Logo"/>
        }

        if (state.fractalState === 2 || state.bitcoinState === 2 || state.fractalState === 0 || state.bitcoinState === 0) {
            return <img src="/img/systems-padding.svg" alt="App Logo"/>
        }

        return <img src="/img/systems-title.svg" alt="App Logo"/>
    }, [state])

    const textTitle = useMemo(() => {
        let textNum = 1

        if (state.fractalState === 2 || state.bitcoinState === 2 || state.fractalState === 0 || state.bitcoinState === 0) {
            textNum = 2
        }
        if (state.fractalState === 0 && state.bitcoinState === 0) {
            textNum = 0
        }
        return StateText(textNum)
    }, [state])


    return <>
        <div className={`flex justify-center mt-[40px] `}>
            <div
                className={`all-systems-operational-600 ${iconClass} px-[54px] py-[18px]  rounded-[20px] flex items-center`}>

                {iconSvg}
                <span className="ml-[12px] text-[24px] font-[600]">{textTitle}</span>
            </div>
        </div>
        <div className={`flex justify-center mt-[27px]`}>
            <div className={`flex text-[#FFFFFF65] items-center flex-block-600`}>
                <div>
                    Last Updated: {titleTime}
                </div>
                <div className={`px-[20px] hide-in-600`}>|</div>
                <div className={`flex items-center mt-20-600`}>
                    Refresh in: <div className={`flex state-title-countdown text-white ml-[8px]`}>
                    <Statistic title="" valueStyle={{color: '#fff', fontSize: 14, lineHeight: '14px'}}
                               value={countDown.M}
                    />m</div>
                    <span className={`px-[4px]`}>:</span>
                    <div className={`flex state-title-countdown text-white`}>
                        <Countdown title="" valueStyle={{color: '#fff', fontSize: 14, lineHeight: '14px'}}
                                   value={countDown.S}
                                   format={'ss'}
                                   onFinish={countDownChange}
                        />s
                    </div>

                </div>
            </div>
        </div>
        <div className={`flex justify-center`}>
            <div className={`text-[#FFFFFF65] mt-[34px] flex`}>
                <div className={`flex items-center`}>
                    <span className={`state-title-operational mr-[6px]`}></span>
                    System Operational
                </div>
                <div className={`flex items-center ml-[40px]`}>
                    <span className={`state-title-degraded mr-[6px]`}></span>
                    Degraded Service
                </div>
            </div>
        </div>
    </>
}